import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  disabled: {
    opacity: '0.7 !important',
    useSelect: 'none !important',
    color: 'white !important',
  },
  button: props => ({
    minWidth: props.minWidth,
    color: 'white',
    width: props.width,
    height: props.small ? 'auto' : props.height,
    textTransform: 'none',
    padding: props.small ? '6px' : '10px',
    opacity: '1',
    useSelect: 'all',
    border: props.type === 'quaternary' ? '1px solid white' : 'none',
    background: '#5664D2',
    // '&:hover': {
    //   background: '#5664D2',
    //   opacity: 0.5,
    //   color: props.type === 'quaternary' ? '#33394B' : 'white',
    // },
    // '&:focus': {
    //   background: ButtonColorTypes[props.type].focus,
    //   color: props.type === 'quaternary' ? '#33394B' : 'white',
    // },
    fontSize: props.small ? '12px' : '14px',
    lineHeight: props.small ? '12px' : '21px',
  }),
}))
